import { FooterProps } from 'react-table';
import { isPopulatedArray } from './funcs';

export const getTableFieldTotal = (props: FooterProps<any>, field: string) => {
  
  if (! (props && props?.rows && isPopulatedArray(props.rows))) return 0;

  return props.rows.reduce((sum, row) => {             
    if (row?.values && row.values.hasOwnProperty(field)) {      
      sum += parseFloat(`0${row.values[field]}`);
    }
    return sum;
  }, 0)

}

